import React from 'react';
import { useTranslation } from 'react-i18next';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function FinancialLicense() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.financial-license.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const textBlocks = (k) => [{ items: (obj(k) || []).map((text) => ({ text })) }];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/financial-license"
            />
            <IntroSection
                title={tp('intro.title')}
                subtitle={tp('intro.subtitle')}
                description={tp('intro.description')}
                badges={obj('intro.badges')}
                buttonText={tp('intro.button')}
                buttonLink="/quote"
                imageSrc={require('../../../assets/images/financial-license/financial-license.png')}
                imageAlt={tp('intro.imageAlt')}
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title={tp('where.title')}
                        subtitle={tp('where.subtitle')}
                        blocks={textBlocks('where.items')}
                    />

                    <WhySection
                        title={tp('covers.title')}
                        subtitle={tp('covers.subtitle')}
                        blocks={[{ items: obj('covers.items') }]}
                    />

                    <WhySection
                        title={tp('whyChoose.title')}
                        blocks={textBlocks('whyChoose.items')}
                    />

                    <WhySection
                        title={tp('techBanking.title')}
                        subtitle={tp('techBanking.subtitle')}
                        blocks={textBlocks('techBanking.items')}
                    />

                    <InfoBlocks
                        title={tp('roadmap.title')}
                        subtitle={tp('roadmap.subtitle')}
                        blocks={textBlocks('roadmap.items')}
                    />

                    <ServiceCards
                        title={tp('useCases.title')}
                        subtitle={tp('useCases.subtitle')}
                        services={(obj('useCases.services') || []).map((title) => ({ title }))}
                    />

                    <WhySection
                        title={tp('topJur.title')}
                        blocks={textBlocks('topJur.items')}
                    />

                    <FAQList data={obj('faq.items')} title={tp('faq.title')}/>

                    <Testimonials
                        title={tp('testimonials.title')}
                        testimonials={obj('testimonials.items')}
                    />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};
